import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDate, IsNotEmpty, IsString } from 'class-validator';
import { PromotionTtlUserExposeGroup } from '../interface';
export class BatchCreateUserPromotionTtlDto {
}
__decorate([
    Expose({ groups: [PromotionTtlUserExposeGroup.CREATE] }),
    IsArray({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true, each: true }),
    ApiProperty({
        type: () => String,
        isArray: true,
        description: 'List of user ids allowed to use the promotion',
        example: ['1428580440530592', '1514680625217367'],
    }),
    __metadata("design:type", Array)
], BatchCreateUserPromotionTtlDto.prototype, "userIds", void 0);
__decorate([
    Expose({ groups: [PromotionTtlUserExposeGroup.CREATE] }),
    Type(() => Date),
    IsDate({ always: true }),
    IsNotEmpty({ always: true }),
    ApiProperty({
        type: () => Date,
        description: 'Time until user is available to use the promotion',
        example: '2020-10-29',
    }),
    __metadata("design:type", Date)
], BatchCreateUserPromotionTtlDto.prototype, "expireAt", void 0);
//# sourceMappingURL=batch-create-user-promotion-ttl.dto.js.map